import React, { Component } from "react"
import axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"
import { Button, Modal } from "react-bootstrap"
import notificationStore from "src/utilities/Notifications/notificationStore"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import DynamicFormTaskTypes from "src/pages/dynamic_forms/Types/DynamicFormTaskTypes"
import mutator from "src/utilities/mutator"
import DynamicFormTypes from "src/pages/dynamic_forms/Types/DynamicFormsTypes"
import FieldTypes from "src/pages/dynamic_forms/Types/FieldTypes"
import completeFormTaskBoiler from "src/pages/dynamic_forms/Utils/CompleteFormTaskBoiler"
import paletteEngine from "src/pages/dynamic_forms/Utils/paletteEngine"
import DynamicForm from "src/pages/dynamic_forms/DynamicForm/DynamicForm"
import snackBar from "src/utilities/snackBar/SnackBar"
import saveSetUp from "src/pages/dynamic_forms/Utils/SaveSetup"
import DynamicFormNormalizedReferenceTypes from "src/pages/dynamic_forms/Types/DynamicFormNormalizedReferenceTypes"
import LDSEllipsis from "src/components/common/LDS/LDSEllipsis/LDSEllipsis"
import TaskManagerTasksModalHeader from "../TaskManagerTaskModalHeader/TaskManagerTaskModalHeader"
import "./TaskManagerTaskFiller.css"
interface Props {
    manageParentState: Function
    callParentFunction: Function
    task: DynamicFormTaskTypes
    palette: Array<DynamicFormPaletteTypes>
    activeViewId: number
    loggedInUser: { userId: string | number, userName: string }
    formReference: DynamicFormNormalizedReferenceTypes
}

interface State {
    tasks: Array<DynamicFormTaskTypes>
    showDebug: boolean
    working: boolean
    saving: boolean
}

class TaskManagerTaskFiller extends Component<Props, State> {

    date = new Date();
    timeZoneOffset = -this.date.getTimezoneOffset()
    taskDex = 0

    state = {
        tasks: [],
        showDebug: false,
        working: false,
        saving: false
    }

    componentDidMount() {
        this.getDynamicFormTasks()
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    getDynamicFormTasks = () => {
        this.manageState([{ key: "working", value: true }])
        axios.get(process.env.REACT_APP_API_URL + `/api/company/GetEmployeeDynamicFormTasks/${this.props.loggedInUser.userId}/*`, AxiosConfig.configValue("min"))
            .then((res) => {
                const tasks = res.data
                this.manageState([{ key: "tasks", value: tasks }, { key: "working", value: false }])
            }).catch(err => {
                //console.log(err)
                this.manageState([{ key: "working", value: false }])
                snackBar({ text: "Error fetching form task", type: "error", timeout: 3000 })
            })
    }

    scaffoldTask = (task: DynamicFormTaskTypes) => {
        const tasks: Array<DynamicFormTaskTypes> = this.state.tasks

        for (let i = 0; i < tasks.length; i++) {
            if (tasks[i].DynamicFormWorkFlowId === task.DynamicFormWorkFlowId) {
                this.taskDex = i
                return {
                    task: tasks[i],
                    form: tasks[i].DynamicForm,
                    scema: JSON.parse(JSON.stringify(tasks[i].DynamicForm.FieldsSchema))
                }
            }
        }
    }

    sumbit = (form: DynamicFormTypes, template: Array<Array<FieldTypes>> | [[]]) => {
        this.manageState([{ key: "saving", value: true }])
        //@ts-ignore
        const fd = saveSetUp.setUpSave(form, template, this.props.loggedInUser.userId, this.props.palette, false)
        let rb = {
            ...{ ...fd },
            ...{ FieldsSchema: form.FieldsSchema },
            ...{ FieldsValues: fd.Fields },
            ...{ EmployeeId: this.props.loggedInUser.userId },
            ...{ CustomFormDataId: 0 }
        }
        delete rb.Fields
        axios.post(process.env.REACT_APP_API_URL + "/api/Data/SaveDynamicFormData", rb, AxiosConfig.configValue("min"))
            .then((res) => {
                if (typeof (res.data) !== "number") {
                    snackBar({ text: "Error saving form task (submit)", type: "error", timeout: 3000 })
                } else {
                    this.saveTask(this.state.tasks[this.taskDex], res.data)
                }
            }).catch((err: any) => {
                //console.log(err)
                this.manageState([{ key: "saving", value: false }])
                snackBar({ text: "Error saving form task (submit)", type: "error", timeout: 3000 })
            })
    }

    saveTask = (helper: DynamicFormTaskTypes, CustomFormDataId: number,) => {
        const user = {
            userId: this.props.formReference.TargetUserId,
            userName: this.props.formReference.employee.UserLogin,
            ...this.props.formReference.employee
        }
        const completedTask = completeFormTaskBoiler.generateCompletedTask(helper, user, CustomFormDataId)
        axios.post(process.env.REACT_APP_API_URL + "/api/company/SaveDynamicFormTask", { tasks: [completedTask] }, AxiosConfig.configValue("min"))
            .then((res) => {
                let errs = 0
                const resp = res.data
                for (let i = 0; i < resp.length; i++) {
                    if (!resp[i].error.success) {
                        errs++
                    }
                }
                if (errs > 0) {
                    snackBar({ text: "Error saving form task (saveTask)", type: "error", timeout: 3000 })
                } else {
                    snackBar({ text: "Task completed", type: "primary", timeout: 3000 })
                    notificationStore.getNotifications(this.props.loggedInUser.userId)
                    this.manageState([{ key: "saving", value: false }])
                    this.props.callParentFunction("setView", this.props.activeViewId)
                }

            }).catch((err: any) => {
                //console.log(err)
                this.manageState([{ key: "saving", value: false }])
                snackBar({ text: "Error saving form task (saveTask)", type: "error", timeout: 3000 })
            })
    }

    render() {

        const state = this.state
        const props = this.props
        const viewItem = this.scaffoldTask(props.task)
        const backgroundColor = `${paletteEngine.getPaletteColor("formBackgroundColor")}`
        const inputTextColor = `${paletteEngine.getPaletteColor("fieldInputTextColor")}`
        const headerTextColor = `${paletteEngine.getPaletteColor("headerTextColor")}`

        // //console.log("TaskManagerTaskFiller state", state)
        // //console.log("TaskManagerTaskFiller props", props)
        // //console.log("TaskManagerTaskFiller taskManagerUtils.lookupItem()",taskManagerUtils.lookupItem(`${props.task.DynamicFormWorkFlowId}`))

        return (
            <div className="TaskManagerTaskFiller">
                <Modal id="task-prompter-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    size={"lg"}
                >
                    <Modal.Header style={{ backgroundColor: backgroundColor }}>
                        <TaskManagerTasksModalHeader
                            workFlowId={props.task.DynamicFormWorkFlowId}
                            fetching={state.working}
                            saving={state.saving}
                            showDebug={state.showDebug}
                            backgroundColor={backgroundColor}
                            inputTextColor={inputTextColor}
                            headerTextColor={headerTextColor}
                            manageParentState={this.manageState}
                            viewItem={viewItem}
                        />
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: backgroundColor }}>
                        <div className="TaskManagerTaskFillerModalBody">
                            {!state.working && viewItem && <DynamicForm
                                form={viewItem.form}
                                addOrRemoveColumn={() => null}
                                submit={this.sumbit}
                                palette={props.palette}
                            />}
                            {state.working && <div className="TaskManagerTaskFillerModalBodyWorking">
                                <LDSEllipsis />
                            </div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ backgroundColor: backgroundColor }}>
                        <div className="TaskManagerTaskFillerModalFooter">
                            <Button variant="secondary" onClick={() => this.props.manageParentState([{ key: "taskToComplete", value: null }])}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default TaskManagerTaskFiller